// extracted by mini-css-extract-plugin
export default {"loader_container":"Loading_loader_container__hPvoK","loader":"Loading_loader__O9ZPs"};